// src/pages/Users.js
import React, { useEffect, useState } from 'react';
import { getAllUsers, toggleUserStatus } from '../services/api';

export default function Users() {
  const [users,   setUsers]   = useState([]);
  const [loading, setLoading] = useState(true);
  const [search,  setSearch]  = useState('');
  const [toggling, setToggling] = useState(null);

  const loadUsers = () => {
    setLoading(true);
    getAllUsers()
      .then(res => setUsers(res.data?.data || []))
      .catch(console.error)
      .finally(() => setLoading(false));
  };

  useEffect(() => { loadUsers(); }, []);

  const handleToggle = async (user) => {
    const action = user.active ? 'deactivate' : 'activate';
    if (!window.confirm(`Are you sure you want to ${action} ${user.name}?`)) return;
    setToggling(user.id);
    try {
      await toggleUserStatus(user.id);
      loadUsers();
    } catch (err) {
      alert('Failed to update user status');
    } finally {
      setToggling(null);
    }
  };

  const filtered = users.filter(u =>
    u.name?.toLowerCase().includes(search.toLowerCase()) ||
    u.phone?.includes(search) ||
    u.email?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div>
      <div className="page-header">
        <div>
          <h1>Users</h1>
          <p>Manage registered users</p>
        </div>
        <button className="btn btn-secondary" onClick={loadUsers}>🔄 Refresh</button>
      </div>

      <div className="card">
        <div className="filter-bar">
          <input
            type="text"
            placeholder="Search by name, phone or email..."
            value={search}
            onChange={e => setSearch(e.target.value)}
            style={{ minWidth: 280 }}
          />
          <span style={{ color: '#666', fontSize: 13 }}>
            {filtered.length} user{filtered.length !== 1 ? 's' : ''}
          </span>
        </div>

        {loading ? (
          <div className="loading"><div className="spinner" />Loading users...</div>
        ) : filtered.length === 0 ? (
          <div className="empty-state">
            <div className="empty-icon">👥</div>
            <p>No users found</p>
          </div>
        ) : (
          <div className="table-wrapper">
            <table>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Name</th>
                  <th>Phone</th>
                  <th>Email</th>
                  <th>Vehicles</th>
                  <th>Family Members</th>
                  <th>Orders</th>
                  <th>Status</th>
                  <th>Joined</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map((user, idx) => (
                  <tr key={user.id}>
                    <td style={{ color: '#888' }}>{idx + 1}</td>
                    <td><strong>{user.name}</strong></td>
                    <td>{user.phone}</td>
                    <td style={{ fontSize: 12 }}>{user.email || '—'}</td>
                    <td style={{ textAlign: 'center' }}>{user.vehicleCount ?? '—'}</td>
                    <td style={{ textAlign: 'center' }}>{user.familyMemberCount ?? '—'}</td>
                    <td style={{ textAlign: 'center' }}>{user.orderCount ?? '—'}</td>
                    <td>
                      <span className={`badge ${user.active ? 'badge-success' : 'badge-danger'}`}>
                        {user.active ? 'Active' : 'Inactive'}
                      </span>
                    </td>
                    <td style={{ fontSize: 12, color: '#666' }}>
                      {user.createdAt
                        ? new Date(user.createdAt).toLocaleDateString('en-IN')
                        : '—'}
                    </td>
                    <td>
                      <button
                        className={`btn btn-sm ${user.active ? 'btn-danger' : 'btn-success'}`}
                        onClick={() => handleToggle(user)}
                        disabled={toggling === user.id}
                      >
                        {toggling === user.id
                          ? '...'
                          : user.active ? 'Deactivate' : 'Activate'}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
